import React from 'react'
import MaterialSymbol from '../material-symbol'

const GroupAdd = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="group_add" {...props} />
))

GroupAdd.displayName = 'GroupAdd'

export default GroupAdd
